import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { from } from 'rxjs';
import { IconComponent } from '../../shared/icon/icon.component';
import { FlightRouteContent, isInternational, loadFlightRoutes } from '../flight-route.model';
import { RouteCardComponent } from '../route-card/route-card.component';

interface RouteGroup {
  title: string;
  routes: FlightRouteContent[];
}

/**
 * Home page route grid: links to every flight route landing page, split into
 * tabs. The same links are prerendered into index.html by scripts/seo-prerender.mjs.
 */
@Component({
  selector: 'app-home-routes',
  imports: [IconComponent, RouteCardComponent],
  templateUrl: './home-routes.component.html',
  styleUrls: ['./home-routes.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeRoutesComponent {
  private readonly routes = toSignal(from(loadFlightRoutes()), { initialValue: [] as readonly FlightRouteContent[] });

  readonly groups = computed<RouteGroup[]>(() => {
    const routes = this.routes();
    if (!routes.length) {
      return [];
    }
    return [
      { title: 'Domestic flights', routes: routes.filter(route => !isInternational(route)) },
      { title: 'East Africa & international', routes: routes.filter(route => isInternational(route)) }
    ];
  });

  readonly active = signal(0);
}
